import {
  AlignRightOutlined,
  FileDoneOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";

const CategorySidebar = ({ categoryId }): ReactElement => {
  const pathname = window.location?.pathname;

  return (
    <>
      <div className="h-100 product-details-wrapper-content">
        <div className="aside-menu">
          <Menu
            defaultSelectedKeys={["0"]}
            // defaultOpenKeys={['sub1']}
            mode="inline"
          >
            <Menu.Item
              key="details"
              className={
                pathname.includes(`/global-categories/${categoryId}/details`)
                  ? "active"
                  : ""
              }
              icon={<FileDoneOutlined />}
            >
              <Link to={`/global-categories/${categoryId}/details`}>
                Category Details
              </Link>
            </Menu.Item>
            <Menu.Item
              key="shops"
              icon={<AlignRightOutlined />}
              className={
                pathname.includes(
                  `/global-categories/${categoryId}/sub-categories`
                )
                  ? "active"
                  : ""
              }
            >
              <Link to={`/global-categories/${categoryId}/sub-categories`}>
                Sub Categories
              </Link>
            </Menu.Item>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default CategorySidebar;
